import * as React from 'react';
import { motion, AnimatePresence } from 'framer-motion';

import './transitions.less';

export interface IBaseTransitionProps {
    children: React.ReactNode;
    in?: boolean;
    timeout?: number | { enter: number; exit: number };
}

export interface IItemTransitionProps extends IBaseTransitionProps {
    appear?: boolean;
}

export const SimpleFadeTransition: React.FC<IBaseTransitionProps> = ({ 
    children, 
    in: inProp, 
    timeout = { enter: 400, exit: 300 }
}) => {
    const duration = typeof timeout === 'number' ? timeout : timeout.enter;
    
    return (
        <AnimatePresence mode="wait">
            {inProp !== false && (
                <motion.div
                    className="simplefadetransition"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{ duration: duration / 1000 }}
                >
                    {children}
                </motion.div>
            )}
        </AnimatePresence>
    );
};

export const FadeTransition: React.FC<IBaseTransitionProps> = ({ 
    children, 
    in: inProp, 
    timeout = { enter: 500, exit: 300 }
}) => {
    const duration = typeof timeout === 'number' ? timeout : timeout.enter;
    
    return (
        <AnimatePresence mode="wait">
            {inProp !== false && (
                <motion.div
                    className="fadetransition"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{ duration: duration / 1000 }}
                >
                    {children}
                </motion.div>
            )}
        </AnimatePresence>
    );
};

export const SlowFadeTransition: React.FC<IBaseTransitionProps> = ({ 
    children, 
    in: inProp, 
    timeout = { enter: 1000, exit: 400 } 
}) => {
    const duration = typeof timeout === 'number' ? timeout : timeout.enter;
    
    return (
        <AnimatePresence mode="wait">
            {inProp !== false && (
                <motion.div
                    className="slowfadetransition"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{ duration: duration / 1000 }}
                >
                    {children}
                </motion.div>
            )}
        </AnimatePresence>
    );
};

export const ItemTransition: React.FC<IItemTransitionProps> = ({ 
    children, 
    in: inProp, 
    timeout = { enter: 200, exit: 200 }
}) => {
    const duration = typeof timeout === 'number' ? timeout : timeout.enter;
    
    return (
        <AnimatePresence mode="wait">
            {inProp !== false && (
                <motion.div
                    className="itemtransition"
                    initial={{ opacity: 0, y: 10 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -10 }}
                    transition={{ duration: duration / 1000 }}
                >
                    {children}
                </motion.div>
            )}
        </AnimatePresence>
    );
};

export const PageTransition: React.FC<IBaseTransitionProps> = ({ 
    children, 
    in: inProp = true
}) => {
    return (
        <AnimatePresence mode="wait">
            {inProp && (
                <motion.div
                    className="pagestransition"
                    initial={{ opacity: 0, x: 10 }}
                    animate={{ opacity: 1, x: 0 }}
                    exit={{ opacity: 0, x: -10 }}
                    transition={{ duration: 1 }}
                >
                    {children}
                </motion.div>
            )}
        </AnimatePresence>
    );
};
